import * as Tooltip from '@wandb/weave/components/RadixTooltip';
import {IconOnlyPill} from '@wandb/weave/components/Tag';
import React, {useState} from 'react';

import {maybePluralize} from '../../../util/uihelpers';

type FoundPanelsPillProps = {
  isGlobalQuickAdd: boolean;
  numPanelsGlobal: number;
  numPanelsInScope: number; // scope may be global or a specific section
};

export const FoundPanelsPill = ({
  isGlobalQuickAdd,
  numPanelsGlobal,
  numPanelsInScope,
}: FoundPanelsPillProps) => {
  const [isTooltipOpen, setIsTooltipOpen] = useState(false);

  return (
    <Tooltip.Provider>
      <Tooltip.Root open={isTooltipOpen} onOpenChange={setIsTooltipOpen}>
        <Tooltip.Trigger>
          <IconOnlyPill
            icon="checkmark"
            color={numPanelsInScope > 0 ? 'green' : 'moon'}
            isInteractive
          />
        </Tooltip.Trigger>
        <Tooltip.Content>
          This key is used by {maybePluralize(numPanelsGlobal, 'panel')}
          {isGlobalQuickAdd
            ? '.'
            : ` (${numPanelsInScope || 'none'} in this section).`}
        </Tooltip.Content>
      </Tooltip.Root>
    </Tooltip.Provider>
  );
};
